'use strict';

var Collapse = require('./collapse');

var Dropdown = function(config) {

  var self = this;
  var $item = config.filterItem;
  var $button = config.button;
  var $dropdown = config.dropdown;
  var $dropdownList = config.dropdownList;

  self.init = function() {
    new Collapse($item, $button, $dropdown, $dropdownList).init();
  }
};

module.exports = Dropdown;
